import { render, staticRenderFns } from "./blogDetails.vue?vue&type=template&id=64d9fb02&scoped=true"
import script from "./blogDetails.vue?vue&type=script&lang=js"
export * from "./blogDetails.vue?vue&type=script&lang=js"
import style0 from "./blogDetails.vue?vue&type=style&index=0&id=64d9fb02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9fb02",
  null
  
)

export default component.exports